import { InsightsRecording } from "@/types/insightsApi";

export function getRecordingUrl(recording: InsightsRecording): string {
  return `https://api.twilio.com/2010-04-01/Accounts/${recording.accountSid}/Recordings/${recording.sid}.wav`;
}
